window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
import 'jquery-ui/ui/widgets/datepicker.js'
// import './notify.min.js';
try {
    require('bootstrap');
    require('bootstrap-colorpicker');
    require('admin-lte');
    require('select2');
    require('datatables.net-bs4');
    window.$ = window.jQuery = $;

    require('bootstrap-tagsinput/src/bootstrap-tagsinput');

} catch (e) { }

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
*/

window.toastr = require('toastr');
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo";
// window.io = require('socket.io-client');
// window.Echo = new Echo({
//     broadcaster: 'socket.io',
//     host: window.location.hostname
// });
